import { getKioskConfig } from '../shared/kiosk-config';

let pledgePayConfig = {};

function isPledgePayConfigConfigured(config) {
    return !!(config && (config.memberPledgePaymentContextUrl || config.pledgeBillPaymentPostUrl));
}

function configurePledgePay(config) {
    if (!config || typeof config !== 'object') {
        throw new Error('configurePledgePay: config is required');
    }
    pledgePayConfig = config;
    return pledgePayConfig;
}

function hasPledgePayConfig() {
    return isPledgePayConfigConfigured(pledgePayConfig);
}

function getPledgePayConfig() {
    if (!isPledgePayConfigConfigured(pledgePayConfig)) {
        throw new Error('getPledgePayConfig: pledge pay config is not registered');
    }
    return pledgePayConfig;
}

function getPledgePayOpenCreditCardLabel(gatewayId) {
    const labels = pledgePayConfig.openCreditCardLabels || {};
    return String(labels[String(gatewayId)] || '');
}

function getPledgePayMemberContextUrl() {
    return getPledgePayConfig().memberPledgePaymentContextUrl || '';
}

function getPledgePaySurchargeAmt() {
    if (pledgePayConfig.surchargeAmt !== undefined && pledgePayConfig.surchargeAmt !== null) {
        return Number(pledgePayConfig.surchargeAmt) || 0;
    }
    return parseFloat(getKioskConfig().surchargeAmt) || 0;
}

function getPledgePayCongregationGatewayCount() {
    if (pledgePayConfig.congregationGatewayCount !== undefined && pledgePayConfig.congregationGatewayCount !== null) {
        return Number(pledgePayConfig.congregationGatewayCount);
    }
    return Number(window.congregationGatewayCount);
}

export {
    configurePledgePay,
    getPledgePayConfig,
    hasPledgePayConfig,
    getPledgePayMemberContextUrl,
    getPledgePaySurchargeAmt,
    getPledgePayCongregationGatewayCount,
    getPledgePayOpenCreditCardLabel,
};
